'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _form = require('../form');

var _form2 = _interopRequireDefault(_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidFormFactory(formPath) {
  function isValidForm(_ref) {
    var state = _ref.state,
        path = _ref.path,
        resolve = _ref.resolve;

    var formValue = resolve.value((0, _form2.default)(formPath));

    return formValue.isValid ? path.true() : path.false();
  }

  return isValidForm;
}

exports.default = isValidFormFactory;
//# sourceMappingURL=isValidForm.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/forms/lib/operators/isValidForm.js
// module id = 1007
// module chunks = 5